import api from "../../../api/axios";

/**
 * GET FIELD CONFIGS
 *
 * params examples:
 * {
 *   schoolYear,
 *   section,
 *   active
 * }
 */
const getFieldConfigs = async (params = {}) => {
  const response = await api.get("/api/v1/power/field-configs", {
    params,
  });

  return response.data;
};

/**
 * GET FIELD CONFIG BY ID
 */
const getFieldConfigById = async (id) => {
  const response = await api.get(`/api/v1/power/field-configs/${id}`);

  return response.data;
};

/**
 * GET RENDER READY CONFIGS
 */
const getRenderConfigBySchoolYear = async (schoolYearId) => {
  const response = await api.get(
    `/api/v1/power/field-configs/render/${schoolYearId}`,
  );

  return response.data;
};

/**
 * CREATE FIELD CONFIG
 */
const createFieldConfig = async (data) => {
  const response = await api.post("/api/v1/power/field-configs", data);

  return response.data;
};

/**
 * UPDATE FIELD CONFIG
 */
const updateFieldConfig = async ({ id, data }) => {
  const response = await api.patch(`/api/v1/power/field-configs/${id}`, data);

  return response.data;
};

/**
 * DELETE FIELD CONFIG
 */
const deleteFieldConfig = async (id) => {
  const response = await api.delete(`/api/v1/power/field-configs/${id}`);

  return response.data;
};

/**
 * TOGGLE ACTIVE
 */
const toggleFieldConfigActive = async (id) => {
  const response = await api.patch(
    `/api/v1/power/field-configs/${id}/toggle-active`,
  );

  return response.data;
};

/**
 * REORDER FIELD CONFIGS
 */
const reorderFieldConfigs = async (items) => {
  const response = await api.patch("/api/v1/power/field-configs/reorder", {
    items,
  });

  return response.data;
};

/**
 * DUPLICATE FIELD CONFIGS
 */
const duplicateFieldConfigs = async ({
  source_school_year,
  target_school_year,
}) => {
  const response = await api.post("/api/v1/power/field-configs/duplicate", {
    source_school_year,
    target_school_year,
  });

  return response.data;
};

const fieldConfigService = {
  getFieldConfigs,
  getFieldConfigById,
  getRenderConfigBySchoolYear,
  createFieldConfig,
  updateFieldConfig,
  deleteFieldConfig,
  toggleFieldConfigActive,
  reorderFieldConfigs,
  duplicateFieldConfigs,
};

export default fieldConfigService;
